import { apiRequest } from "./apiClient";

export function toModelPayload(editorData = {}) {
    const {
        _id,
        title,
        description,
        canvasBg,
        canvasSize,
        elements,
        modelFields,
        mode,
    } = editorData;

    return {
        _id,
        title,
        description: description ?? "",
        data: {
            title,
            canvasBg,
            canvasSize,
            elements,
            modelFields: modelFields || [],
            mode: mode || "model",
        },
    };
}

export function fromApiModel(apiModel) {
    console.log(apiModel)
    const data = apiModel?.data || {};
    return {
        ...apiModel,
        title: apiModel?.title || data.title || "Sans titre",
        description: apiModel?.description || "",
        elements: data.elements || [],
        canvasBg: data.canvasBg || "#ffffff",
        canvasSize: data.canvasSize || { width: 1080, height: 1080 },
        modelFields: data.modelFields || [],
    };
}

export async function listMyModels() {
    const models = await apiRequest("/models", { method: "GET" });
    return Array.isArray(models) ? models.map(fromApiModel) : [];
}

export async function getModelById(id) {
    const query = new URLSearchParams({_id: id}).toString();
    const model = await apiRequest(`/models?${query}`, { method: "GET" });
    if(model.length>0) return fromApiModel(model[0])
    return fromApiModel({});
}

export async function createModel(editorData) {
    const payload = toModelPayload(editorData);
    const model = await apiRequest("/model", {
        method: "POST",
        body: JSON.stringify(payload),
    });
    return fromApiModel(model);
}

export async function updateModel(id, editorData) {
    const payload = toModelPayload(editorData);
    const model = await apiRequest(`/model/${id}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
    return fromApiModel(model);
}

export async function deleteModel(id) {
    return apiRequest(`/model/${id}`, { method: "DELETE" });
}
